const SelectedMuseum = function (props) {
    let museumTitleUpdateBR = props.data.Title;
    museumTitleUpdateBR = museumTitleUpdateBR.replace("<br/>", " ");
    return (
        <div className="selectedItem">
            <div className="selectedTitle"  dangerouslySetInnerHTML={{__html: museumTitleUpdateBR}}></div>
            <img className="selectedImg" src={props.data.ModMuseumImgMap_Url} data-holder-rendered="true"  alt="תמונת מוזיאון"/>
            <div className="selectedDetails">{props.data.MODMuseumText}</div>
            <div className="mapSelectedMuseumButton">
                <a className="selectMuseumLinkNav buttonRoundEdgeDesign" href={props.data.MODNavLink_Url}><span>לניווט</span><i className="fab fa-waze"></i></a>
                <a target="_blank" rel="noopener noreferrer" className="selectMuseumLink buttonRoundEdgeDesign" href={props.data.MODMuseumLink_Url}><span>לאתר המוזיאון</span></a>
            </div>
        </div>
    );
}
export default SelectedMuseum;